import { styled } from "@mui/material"
import TextField from "@mui/material/TextField"

interface GradientTextFieldProps {
  width?: string
  isMobile?: boolean
}

const GradientTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'width',
})<GradientTextFieldProps>(({ width, isMobile }) => ({
    "& .MuiOutlinedInput-root": {
      height: "41px",
      position: "relative",
      borderRadius: "50px",
      padding: "3px",
      zIndex: 1,
      background: "linear-gradient(90deg, #929BED, #F99A7B)",
      // boxShadow: "inset 0px 0px 13.9px 0px #00000040",
      backgroundClip: "padding-box",
      "& fieldset": {
        border: "none", // Remove the default border
      },
      "&:hover fieldset": {
        border: "none", // Remove the hover state border
      },
      "&.Mui-focused fieldset": {
        border: "none", // Remove the focus state border
      },
    },
    "& .MuiOutlinedInput-input, & .MuiSelect-select": {
      position: "relative",
      zIndex: 1,
      boxShadow: "inset 0px 1px 2px 1px rgba(0, 0, 0, 0.3)",
      backgroundColor: "#ffffff",
      borderRadius: "inherit",
      fontSize: isMobile ? "14px" : undefined,
      padding: "0 12px",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      "-webkit-appearance": "none", // Prevent native styling on select dropdowns
      appearance: "none",
    },
    "& .MuiSelect-select": {
      paddingRight: "32px", // Add padding for the dropdown icon
      backgroundColor: "#ffffff", // Ensure the dropdown has a white background
      borderRadius: "inherit",
    },
    "&. Mui-readOnly":{
      fontSize: isMobile ? "1px" : undefined,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none", // Remove the notched outline
    },
    "& .MuiFormLabel-root": {
      top: "-8px",
      color: "#000000",
      fontSize: "14px",
      fontWeight: "bold",
      fontFamily: "Maven Pro",
    },
    "& input": {
      textAlign: "center",
      "&::selection": {
        backgroundColor: "rgba(147, 155, 237, 0.25) !important",
        color: "#000000 !important",
      },
      "&::-moz-selection": {
        backgroundColor: "rgba(147, 155, 237, 0.25) !important",
        color: "#000000 !important",
      },
    },
    "& .MuiFormLabel-root.Mui-focused, & .MuiFormLabel-root.MuiInputLabel-shrink":
      {
        top: "0px",
      },
    "& input:-webkit-autofill": {
      WebkitTextFillColor: "#000",
      transition: "background-color 5000s ease-in-out 0s",
    },
    width: width || "90%",
    marginBottom: "14px",
  })
)

export default GradientTextField
